"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportContext = void 0;
const react_1 = require("react");
exports.ExportContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=export-context.js.map